export default {
  keyboard: require('./keyboard').default,
  routes: require('./routes').default,
};
